import React, { useContext, useEffect, useState, useRef } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import MaskedInput from 'react-text-mask';
import Select, { createFilter } from 'react-select';
import lupa from '../../midia/lupa.svg';
import { addMonths, format, startOfMonth, endOfMonth } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import api from '../../services/api';
import { PesquisaSub } from '../Pesquisas/PesquisaSub';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { Functions, SetFunctions } from '../../componentes/Functions';
import { useAvisoEventos } from '../Modal/ModalAvisoEventos';

// /-------------------------------------------------
export function PesquisaPadrao(props) {
    const { state, dispatch } = useContext(Context);
    const { listaPesquisa, parametroInit } = state.parametros;
    const { evento } = state.evento;
    const { tipoData } = evento;

    const { PesqFornecedor } = ApiEvento();
    const { EditarSelect } = Functions();
    const { SetEvento } = SetFunctions();
    const { verificarPlaca, modalAviso } = useAvisoEventos();

    const [maisPesquisa, setmaisPesquisa] = useState(false);
    const [porFornec, setporFornec] = useState(false);
    const [porTipoEve, setporTipoEve] = useState(false);
    const [porUsuario, setPorUsuario] = useState(false);
    const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);

    const [dateInicio, setdateInicio] = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'));
    const [dateFim, setdateFim] = useState("");
    const [isTelaPequena, setIsTelaPequena] = useState(() => window.innerWidth < 430);
    
    // --------------
    const dataAtual = format(new Date(), 'yyyy-MM-dd');
    const DiaPrimeiro = format(startOfMonth(new Date()), 'yyyy-MM-dd');
    const DiaUltimo = dateInicio && format(endOfMonth(new Date(dateInicio + 'T00:00:00-03:00')), 'yyyy-MM-dd');
    const mesBaseSeta = dateInicio ? new Date(dateInicio + 'T00:00:00-03:00') : dateFim ? new Date(dateFim + 'T00:00:00-03:00') : new Date();
    const mesAtualRef = format(startOfMonth(new Date()), 'yyyy-MM-dd');
    const mesSelecionadoRef = format(startOfMonth(mesBaseSeta), 'yyyy-MM-dd');
    const podeAvancarMes = mesSelecionadoRef < mesAtualRef;
    const nomeMesSelecionado = format(mesBaseSeta, 'MMMM', { locale: ptBR })

    const nomeMesFormatado = nomeMesSelecionado ? nomeMesSelecionado.charAt(0).toUpperCase() + nomeMesSelecionado.slice(1) : "";

    // -------------
    function AlterarMes(offset) {
        const novoMes = addMonths(mesBaseSeta, offset);
        const novoInicio = format(startOfMonth(novoMes), 'yyyy-MM-dd');
        const ultimoDiaNovoMes = format(endOfMonth(novoMes), 'yyyy-MM-dd');
        const novoFim = ultimoDiaNovoMes > dataAtual ? dataAtual : ultimoDiaNovoMes;

        setdateInicio(novoInicio);
        setdateFim(novoFim);
    };

    // Atualiza layout dos filtros para telas muito pequenas
    useEffect(() => {
        setmaisPesquisa(false);

        setdateInicio((!listaPesquisa.nomeItem) && !dateInicio ? DiaPrimeiro : dateInicio); // se nao tiver Placa, preencher data automatico
        setdateFim(!dateInicio ? "" : new Date() > new Date(DiaUltimo)? DiaUltimo : dataAtual);

        const handleResize = () => {
            setIsTelaPequena(window.innerWidth < 430);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    // --------------
    function SetListaPesquisa(key, value) {
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { ...listaPesquisa, [key]: value }
        });
    };

    // --------------
    async function PesquisarItem() {
        if (props.mostrarFiltroData !== false && dateInicio && typeof props.PesquisarData === 'function') {
            const dados = await props.PesquisarData(
                dateInicio + 'T00:00:00-03:00',
                dateFim + 'T00:00:00-03:00',
                porFornec,
                porTipoEve,
                false,
                tipoData
            );

            if (porUsuario && usuariosSelecionados.length > 0 && Array.isArray(dados)) {
                const dadosFiltrados = dados.filter((item) => usuariosSelecionados.includes(item?.userCadastro?._id));
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaEvento: dadosFiltrados },
                });
            };

        } else if (!dateInicio && (porFornec || porTipoEve)) {
            props.Pesquisar(listaPesquisa.nomeItem, porFornec, porTipoEve);
        
        } else {
            props.Pesquisar(listaPesquisa.nomeItem, false, false);
            if (props.refPlaca) verificarPlaca(listaPesquisa.nomeItem);
        }
    };
    
    // --------------
    const normalizar = (t) => String(t || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
    const ehPreEvento = normalizar(listaPesquisa.SelectForn) === "pre-evento";

    async function selecionarPreEvento(marcado) {
        if (!marcado) {
            SelectFornecedor("", true);
            return;
        }
        try {
            const res = await api.get(`/evento/fornecedor/pre-evento`);
            const forn = (res.data || []).find(f => normalizar(f.nome) === "pre-evento");
            if (!forn) {
                alert("Fornecedor Pre-Evento não encontrado.");
                return;
            }
            setporTipoEve(false);
            setPorUsuario(false);
            setporFornec(true);
            SelectFornecedor({ label: forn.nome, value: forn._id }, true);
        } catch (error) {
            alert("Erro ao buscar o fornecedor Pre-Evento.");
        }
    };

    // --------------------------

    function SelectFornecedor(fornecedor, atualizarFornecedorEvento = false) {
        const nome = fornecedor?.label || "";
        const id = fornecedor?.value || "";
        const preencherPreEvento = atualizarFornecedorEvento === true;
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { 
                ...listaPesquisa, 
                id_nomeForn: id? id : "",
                SelectForn: nome? nome : "",
            }
        });

        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                id_Fornecedor: preencherPreEvento ? id : "",
                fornecedor: preencherPreEvento
                    ? (nome ? "pre-evento" : normalizar(evento.fornecedor) === "pre-evento" ? "" : evento.fornecedor)
                    : evento.fornecedor,
            }
        });
    };

    // --------------
    function selecionarUsuario(id) {
        setUsuariosSelecionados((selecionados) => selecionados.includes(id)
            ? selecionados.filter((usuarioId) => usuarioId !== id)
            : [...selecionados, id]);
    };

    // -------------
    async function filtrarPorUsuarios() {
        if (usuariosSelecionados.length === 0) {
            alert('Selecione ao menos um usuário para filtrar.');
            return;
        }

        await PesquisarItem();
    }
    // --------------
    const [pesquisarTudo_Forn, setpesquisarTudoForn] = useState(false);
    const [pesquisarTudo_Tipo , setpesquisarTudoTipo] = useState(false);
    const [pesquisarTudoUser, setpesquisarTudoUser] = useState(false);
    // --------------
    function FecharLista(){
        setporFornec(false);
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { 
                ...listaPesquisa, 
                id_nomeForn: "",
                SelectForn: "",
                listaFornecedor: [],
            }
        });

        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                id_Fornecedor: "",
            }
        });
        setpesquisarTudoForn(true);
    };

    // --------------
    function FecharListaUser(){
        setPorUsuario(false);
        setUsuariosSelecionados([]);
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { 
                ...listaPesquisa, 
                id_nomeUser: "",
                SelectUser: "",
                listaUsuario: [],
            }
        });

        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                id_UserCadastro: "",
            }
        });
        setpesquisarTudoUser(true);
    };
    // --------------
    
    useEffect(() => {
        if(pesquisarTudo_Forn && !listaPesquisa.SelectForn){
            PesquisarItem();
            setpesquisarTudoForn(false);
            setmaisPesquisa(false);
        }       
    }, [pesquisarTudo_Forn])
    // --------------
    
    useEffect(() => {
        if(pesquisarTudoUser && usuariosSelecionados.length === 0){
            PesquisarItem();
            setpesquisarTudoUser(false);
            setmaisPesquisa(false);
        }       
    }, [pesquisarTudoUser])
    // --------------

    useEffect(() => {
        if(pesquisarTudo_Tipo && !evento.tipoEvento){
            PesquisarItem();
            setpesquisarTudoTipo(false);
            setmaisPesquisa(false);
        }       
    }, [pesquisarTudo_Tipo])
    // --------------

    useEffect(() => {
        if (!porFornec && !porTipoEve && !porUsuario && !tipoData) {
            setmaisPesquisa(false);
        };
        

        if(tipoData || (dateInicio && dateFim)){
            PesquisarItem();
        }       
    }, [tipoData, dateFim])

    // -----------
    function FuncMaisPesquisa(){
        setmaisPesquisa(!maisPesquisa); 
        if(maisPesquisa){
            setporFornec(false); 
            setporTipoEve(false); 
            setPorUsuario(false);
            setUsuariosSelecionados([]);

            dispatch({
                type: 'set_ListaPesquisa',
                payload: { 
                    ...listaPesquisa, 
                    listaFornecedor: [],
                    id_nomeForn: "",
                    SelectForn: "",
                    id_nomeUser: "",
                    SelectUser: "",
                }
            });

            dispatch({
                type: 'set_Evento',
                payload: {
                    ...evento,
                    id_Fornecedor: "",
                    id_UserCadastro: "",
                    tipoEvento: "",
                }
            });
        }
    };
    
    // --------------
    useEffect(() => {
        if (dateInicio) {
            setdateInicio((!listaPesquisa.nomeItem) && !dateInicio ? DiaPrimeiro : dateInicio); // se nao tiver Placa, preencher data automatico
            setdateFim(!dateInicio ? "" : new Date() > new Date(DiaUltimo)? DiaUltimo : dataAtual);
        } else {
            setdateInicio("");
            setdateFim("");
        }
    }, [dateInicio])

    // -----------------
    useEffect(() => {
        // setdateInicio("");
        // setdateFim("");
        setmaisPesquisa(false);
        setporFornec(false); 
        setporTipoEve(false); 
        // if (!props.PesqDentroModal) SetEvento("tipoEvento", ""); // evita apagar o tipoEvento já selecionado no ModalEvento

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                nomeForn: "",
                SelectForn: "",
                id_nomeForn: "",
                listaFornecedor: [],
                alertaNovo: false
            }
        });

        if (!listaPesquisa.nomeItem) {
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaVeiculo: [],
                    listaCliente: [],
                    listaFornecedor: [],
                    nomeItem: ""
                }
            });
        }
    }, [listaPesquisa.nomeItem]);

    // --------------    
    
    //###################################################################################################
    return (
        <S.divInfor>
            {modalAviso}
            
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {props.titulo}
                {props.mostrarPreEvento && evento.tipoEvento === "Colisao_part" &&
                <label style={{ display: "flex", alignItems: "center", gap: "3px", fontSize: "11px", cursor: "pointer", whiteSpace: "nowrap" }}>
                    <input
                        type="checkbox"
                        checked={ehPreEvento}
                        onChange={e => selecionarPreEvento(e.target.checked)}
                        style={{ width: "12px", height: "12px", margin: 0, cursor: "pointer" }}
                    />
                    Pre-Evento
                </label>
                }
            </span>
            <S.ddd>
                {
                props.refCpfCnpj &&
                <>
                {listaPesquisa.nomeItem?.length <= 11 ?
                    <MaskedInput    
                        autoFocus           
                        value={listaPesquisa.nomeItem}
                        type='search'
                        placeholder='cpf/cnpj'
                        mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                        onChange={e => SetListaPesquisa('nomeItem', e.target.value.replace(/\D/gim, ''))}
                        guide={false}
                        style={{fontSize:"clamp(16px, 3vw, 18px)"}}
                    />
                    :
                    <MaskedInput
                        autoFocus
                        value={listaPesquisa.nomeItem}
                        type='search'
                        placeholder='cpf/cnpj'
                        mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                        onChange={e => SetListaPesquisa('nomeItem', e.target.value.replace(/\D/gim, ''))}
                        guide={false}
                        style={{fontSize:"clamp(16px, 3vw, 18px)"}}
                    />
                }
                </>
                }
                {
                    props.refPlaca &&
                    <MaskedInput
                        autoFocus
                        value={listaPesquisa.nomeItem}
                        className='uppercase'
                        type='search'
                        placeholder={props.placeholder}
                        mask={[/\D/, /\D/, /\D/, /\d/, /\w/, /\d/, /\d/]}
                        onChange={e => {
                            // Pesquisa por placa busca tudo: limpa o período enquanto digita
                            setdateInicio('');
                            setdateFim('');
                            SetListaPesquisa('nomeItem', e.target.value);
                        }}
                        guide={false}
                        style={{fontSize:"clamp(16px, 3vw, 18px)"}}
                    />
                }
                {
                    props.refNomeCPF &&
                    <input
                        autoFocus
                        type='search'
                        style={{ textTransform: "capitalize", fontSize:"clamp(16px, 3vw, 18px)" }}
                        placeholder={props.placeholder}
                        value={listaPesquisa.nomeItem}
                        onChange={e => SetListaPesquisa('nomeItem', e.target.value.replace(/[^a-zA-Z0-9 ]/g, ""))}
                    />
                }

                {props.Lupa &&
                    <S.Pesq>
                        <button
                            type='button'
                            onClick={() => { PesquisarItem(); }}>
                            <img src={lupa} />
                        </button>
                    </S.Pesq>
                }
            </S.ddd>

            {/* ------------Botao Novo------------------ */}
            {(props.playBotao || props.playTudo) &&
                <div style={{ display: "flex", justifyContent: "space-between", gap:"5px" }}>
                    <div style={{ display: "flex", flexDirection:"column", width: "100%" }}>
                        <div className='filtrosLinha'>

                            {props.playBotao &&
                            <S.botao>
                                <div
                                    className='abrirModal'
                                    style={{height:"20px"}}
                                    onClick={() => props.playModal_Add()}
                                >
                                    {props.nomeBotao}
                                </div>
                            </S.botao>
                            }

                            {/* {-------- FILTROS - data ------------} */}

                            {props.mostrarFiltroData !== false &&
                            <div className='filtrosDataGroup'>
                                <div className='datasInicioFim' style={{ display: "flex", justifyContent: "space-between", gap: "10px", alignItems: "flex-end" }}>
                                    <button
                                        type='button'
                                        onClick={() => AlterarMes(-1)}
                                        style={{ height: "28px", minWidth: "28px", cursor: "pointer" }}
                                        title='Mes anterior'
                                    >
                                        {'<'}
                                    </button>
                                    
                                    {isTelaPequena ?
                                    <div className='selectData' style={{ minWidth: '70px', alignItems: 'center' }}>
                                        <span style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>
                                            {nomeMesFormatado}
                                        </span>
                                    </div>
                                    :
                                    <>
                                        <div className='selectData'>
                                            <span>incio</span>
                                            <input
                                            type='date'
                                            max={dataAtual}
                                            value={dateInicio}
                                            onChange={(e) => {
                                                if (e.target.value) {
                                                    setdateInicio(e.target.value);
                                                } else if (listaPesquisa.nomeItem) {
                                                    // com Placa/nome preenchido, o usuário pode limpar a data
                                                    setdateInicio("");
                                                    setdateFim("");
                                                }
                                            }}
                                            />
                                        </div>
                                        <div className='selectData'>
                                            <span>fim</span>
                                            <input
                                            value={dateFim}
                                            onChange={(e) => setdateFim(e.target.value || dataAtual)}
                                            type='date'
                                            min={dateInicio}
                                            max={dataAtual}
                                            />
                                        </div>
                                    </>
                                    }

                                    <button
                                        type='button'
                                        onClick={() => AlterarMes(1)}
                                        disabled={!podeAvancarMes}
                                        style={{ height: "28px", minWidth: "28px", cursor: podeAvancarMes ? "pointer" : "not-allowed" }}
                                        title='Proximo mes'
                                    >
                                        {'>'}
                                    </button>
                                </div>
                            </div>
                            }

                            {/*--------- MAIS ---------- */}
                            {props.mostrarMais !== false &&
                            <div style={{ display: "flex",}}>
                                
                                <span
                                    style={{ display: "flex", color: "yellow", alignItems: "center", cursor: "pointer" }}
                                    onClick={() => FuncMaisPesquisa()}
                                >
                                    mais
                                </span>
                                
                            </div>
                            }
                        </div>

                        { /* ---------MAIS PESQUISA---------- */ 
                        props.mostrarMais !== false && maisPesquisa &&
                        <div style={{display:"flex", flexDirection:"column", gap:"5px"}}>  
                            {listaPesquisa.listaEvento.length > 0 &&
                            <>    


                            {/* lista de opções de pesquisa */}
                            <div 
                            style={{cursor:"pointer", display: tipoData || porTipoEve || porUsuario ? "none" : "flex", backgroundColor:"#30353f", alignItems:"center"}}
                            onClick={()=> {setporFornec(true); setporTipoEve(false); SetEvento('tipoEvento', "")}}
                            >
                                <span style={{color: "yellow", overflow: "hidden", whiteSpace:"nowrap", padding:"5px"}}> 
                                    Por Fornecedor 
                                </span>
                            </div>
                            
                            <div 
                            style={{cursor:"pointer", display: tipoData || porFornec || porUsuario ? "none" : "flex", backgroundColor:"#30353f", alignItems:"center"}}
                            onClick={()=> {setporTipoEve(true); setporFornec(false); EditarSelect("RefFornecedor") }}
                            >
                                <span style={{color: "yellow", padding:"5px"}}> Por Evento </span>
                            </div>

                            <div 
                            style={{cursor:"pointer", display: tipoData || porTipoEve || porFornec? "none" : "flex", backgroundColor:"#30353f", alignItems:"center"}}
                            onClick={()=> {setPorUsuario(true); setporFornec(false); setporTipoEve(false); SetEvento('tipoEvento', "")}}
                            >
                                <span style={{color: "yellow", overflow: "hidden", whiteSpace:"nowrap", padding:"5px"}}> Por Usuario </span>
                            </div>

                            {/* --------------Por Tipo Data---------------------- */
                            (!porFornec && !porTipoEve && !porUsuario) &&
                            <div className='selectData tipoDataBox'>
                                <select
                                value={tipoData}
                                onChange={(e) => {SetEvento("tipoData", e.target.value);}}
                                >
                                    <option value="" disabled hidden style={{color:"white"}}>Tipo Data</option>
                                    <option value='CADASTRO'>DATA EVENTO</option>
                                    <option value='PAGAMENTO'>DATA PAGAMENTO</option>
                                </select>
                            </div>     
                            }
                        
                            {/* { //-------------------- */}
                            
                            { porFornec && 
                            (!listaPesquisa.SelectForn?
                                (listaPesquisa.listaEvento.length > 0 ?
                                <div style={{ display: "flex", gap:"5px" }}>
                                    <Select
                                    styles={{
                                        container: (base) => ({ ...base, width: "100%", maxWidth: "250px", fontSize: "clamp(12px, 3vw, 14px)", textTransform: "uppercase", color: "black" }),
                                    }}
                                    isClearable
                                    isSearchable
                                    filterOption={createFilter({
                                        ignoreAccents: true,
                                        ignoreCase: true,
                                        matchFrom: 'any',
                                        trim: true,
                                    })}
                                    noOptionsMessage={() => "Nenhum fornecedor encontrado"}
                                    options={listaPesquisa.listaFornecedor.map((forn) => ({
                                        value: forn.id,
                                        label: forn.nome,
                                    }))}
                                    placeholder="fornecedor"
                                    
                                    value={listaPesquisa.listaFornecedor
                                        .map((forn) => ({ value: forn.id, label: forn.nome }))
                                        .find((forn) => forn.value === listaPesquisa.id_nomeForn) || null}
                                    onChange={SelectFornecedor}
                                    />
                                </div>

                                :

                                <div style={{ display: "flex", gap:"5px", minWidth:"150px"}}>
                                    <PesquisaSub
                                        nome={listaPesquisa.nomeForn}
                                        nomeItem="nomeForn"
                                        placeholder="Fornecedor"
                                        Pesquisar={PesqFornecedor}
                                        PesqDentroModal={true}
                                        Lupa={true}
                                    />
                                    {listaPesquisa.listaFornecedor.length > 0 &&
                                    <button 
                                    className='bottonAdd'
                                    style={{"color":"white", backgroundColor: "red",}} 
                                    onClick={()=> SetListaPesquisa('listaFornecedor', [])}
                                    >
                                        X
                                    </button>
                                    }
                                </div>
                                )
                            

                            :

                            <div style={{ display: "flex", gap:"5px"}}> 
                                <span
                                style={{ 
                                    display: "flex", 
                                    cursor: "pointer",
                                    width:"100%", 
                                    textTransform: "uppercase", 
                                    backgroundColor: "#30353f", 
                                    padding:"6px 0", 
                                    alignItems:"center",
                                    fontSize: "clamp(12px, 3vw, 14px)",
                                    overflow: "hidden",
                                    whiteSpace:"nowrap"
                                    }}
                                onClick={() => {SelectFornecedor("")}}
                                >
                                    {listaPesquisa.SelectForn}
                                </span>
                                <button 
                                    className='bottonAdd'
                                    style={{"color":"white", backgroundColor: "red",}} 
                                    onClick={()=> {FecharLista()}}
                                    >
                                        X
                                </button>
                            </div>
                            )}                                                   

                            {/* ----Por Evento------ */
                            porTipoEve && 
                            <div>
                                {!evento.tipoEvento ?
                                    listaPesquisa.listaEvento.length > 0 ?
                                    <select
                                        style={{ display: "flex", width: "100%", padding:"5px" }}
                                        value={evento.tipoEvento}
                                        onChange={e => SetEvento('tipoEvento', e.target.value)}
                                        required
                                        >
                                        {parametroInit.editModal &&
                                            <option>{evento.tipoEvento}</option>
                                        }
                                        <option value="" hidden></option>
                                        {listaPesquisa.listaTipoEvento.map(tipo =>
                                            <option key={tipo} value={tipo}>{tipo}</option>
                                        )}
                                        
                                    </select>
                                    :
                                    <select
                                        style={{ display: "flex", width: "100%", height:"20px", padding:"5px" }}
                                        value={evento.tipoEvento}
                                        onChange={e => SetEvento('tipoEvento', e.target.value)}
                                        required
                                        >
                                        {parametroInit.editModal &&
                                            <option>{evento.tipoEvento}</option>
                                        }
                                        <option value="" hidden></option>
                                        <option value="Guincho_Mecanica">Guincho P.Mecanica</option>
                                        <option value="Guincho_Eletrica">Guincho P.Eletrica</option>
                                        <option value="Guincho_Colisao">Guincho Colisao</option>
                                        <option value="Borracheiro">Borracheiro</option>
                                        <option value="Recarga">Recarga Bateria</option>
                                        <option value="C.Reserva">Carro Reserva</option>
                                        <option value="Retorno">Retorno Domicilio</option>
                                        <option value="Hospedagem">Hospedagem</option>
                                        <option value="Chaveiro">Chaveiro</option>

                                        <option value="Vidro_part">Quebra Vidro</option>
                                        <option value="Lanterna_part">Quebra Lanterna</option>
                                        <option value="Retrovisor_part">Quebra Retrovisor</option>
                                        <option value="Reparos_part">Pequeno Reparo</option>
                                        <option value="Colisao_part">Colisão</option>

                                        <option value="Roubo">Roubo Veiculo</option>
                                        <option value="Colisao_PT">Perca Total</option>
                                        <option value="Colisao_Incendio">Incendio</option>
                                    </select>

                                    :
                                    <div style={{ display: "flex", gap:"5px"}}> 
                                        <span
                                            style={{ display: "flex", cursor: "pointer", width:"100%", maxWidth:"250px", textTransform: "uppercase", backgroundColor: "#30353f", height:"20px", alignItems:"center" }}
                                            onClick={() => {SetEvento('tipoEvento', "")}}
                                        >
                                            {evento.tipoEvento}
                                        </span>
                                        <button 
                                        className='bottonAdd'
                                        style={{"backgroundColor":"red","color":"white"}} 
                                        onClick={()=> {SetListaPesquisa('listaTipoEvento', []); SetEvento('tipoEvento', ""); setporTipoEve(false); setpesquisarTudoTipo(true);}}
                                        >
                                            X
                                        </button>
                                    </div>

                                }
                            </div>
                            }

                        
                            {/* ---------POR Usuario---------- */
                            porUsuario &&                             
                            <>
                                {listaPesquisa.listaEvento.length > 0 &&
                                <div style={{ display: "flex", gap:"5px" }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '4px' }}>
                                        {listaPesquisa.listaUsuario.map((user) => (
                                            <label key={user.id || user.nome} style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'white', textTransform: 'uppercase' }}>
                                                {listaPesquisa.listaUsuario.length > 1 &&
                                                <input
                                                    type='checkbox'
                                                    checked={usuariosSelecionados.includes(user.id)}
                                                    onChange={() => selecionarUsuario(user.id)}
                                                    style={{ width: 'auto', margin: 0 }}
                                                />
                                                }
                                                <span>{user.nome}</span>
                                            </label>
                                        ))}
                                    </div>

                                    {listaPesquisa.listaUsuario.length > 1 &&
                                    <>
                                        <button 
                                            className='bottonAdd'
                                            style={{"color":"white", backgroundColor: "red",}} 
                                            onClick={()=> {FecharListaUser()}}
                                            >
                                                X
                                        </button>
                                        <button
                                            type='button'
                                            title='Filtrar por usuários selecionados'
                                            onClick={filtrarPorUsuarios}
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px' }}
                                        >
                                            <img src={lupa} alt='Filtrar por usuários' style={{ width: '17px', height: '17px' }} />
                                        </button>
                                    </>
                                    }
                                </div>
                                }
                            </>
                            }  
                            </>}                                         
                        </div>   
                        }
                    </div>
                </div>
            }
        </S.divInfor>
    )
}